/* ============================================================
   tc60-v7 · Figma export transcript pass (2026-08-05, several rounds)
   Loaded last, after v6.

   §1  · TIMELINE — draggable horizontal filmstrip
   §2  · PRODUCT SLIDER — brand filter + slider-arrow wiring
   §14 · THEN & NOW — before/after drag-to-compare slider

   Read-more toggling and the CAST review-content changes live in
   tc60-v5.js instead of here, next to the data they touch — see
   moreToggle()/wireReadMore() there.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ==========================================================
     §1 · TIMELINE — draggable horizontal filmstrip

     REBUILT (second pass, same day): "the scroll on the timeline is not
     working, pls make it draggable to view the timeline horizontally".
     The original mechanic scrubbed the track via a 460vh runway + sticky
     stage read off the PAGE's vertical scroll position (see git history) —
     replaced outright with `.tlf-frames` as a plain native horizontally-
     scrollable box (touch already drags it) plus pointer-drag for a mouse,
     the same pattern `.pslide-viewport` below already uses. Everything
     downstream of scroll position — ghost year, axis fill/playhead,
     active mark — now reads `.tlf-frames`' own scrollLeft/scrollWidth
     instead of the runway's position in the page. */
  var stage    = document.querySelector('[data-tlf-stage]');
  var track    = document.querySelector('[data-tlf-track]');
  var frameBox = stage ? stage.querySelector('.tlf-frames') : null;
  var frames   = track ? Array.prototype.slice.call(track.querySelectorAll('.tlf-frame')) : [];
  var yearEl   = document.querySelector('[data-tlf-year]');
  var fillEl   = document.querySelector('[data-tlf-fill]');
  var headEl   = document.querySelector('[data-tlf-head]');
  var line     = stage ? stage.querySelector('.tlf-line') : null;
  var marks    = stage ? Array.prototype.slice.call(stage.querySelectorAll('.tlf-mark')) : [];

  if (frameBox && track && frames.length > 1) {
    var span = frames.length - 1;

    function paint() {
      var max = frameBox.scrollWidth - frameBox.clientWidth;
      var p = max > 0 ? clamp(frameBox.scrollLeft / max, 0, 1) : 0;

      var lineW = line ? line.clientWidth : 0;
      if (fillEl) fillEl.style.width = (p * lineW) + 'px';
      if (headEl) headEl.style.left = (p * lineW) + 'px';

      var idx = clamp(Math.round(p * span), 0, span);
      marks.forEach(function (m, i) { m.classList.toggle('active', i === idx); });

      if (yearEl) yearEl.textContent = String(1966 + Math.round(p * 60));
    }

    var pending = false;
    function queue() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; paint(); });
    }
    frameBox.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    queue();

    /* click a year marker to jump straight to that frame */
    marks.forEach(function (mark, i) {
      mark.addEventListener('click', function () {
        var max = frameBox.scrollWidth - frameBox.clientWidth;
        if (max <= 0) return;
        frameBox.scrollTo({ left: max * (i / span), behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* Pointer-drag for a mouse: overflow-x:auto scrolls natively with
       touch and a trackpad, but a plain mouse drag does nothing to an
       overflow box on its own — this turns pointer movement into
       scrollLeft, same idea as the award ring's own drag-to-spin. */
    var dragging = false, moved = false, startX = 0, startLeft = 0;
    frameBox.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch already scrolls natively
      dragging = true; moved = false;
      startX = e.clientX; startLeft = frameBox.scrollLeft;
      frameBox.classList.add('is-dragging');
      frameBox.setPointerCapture(e.pointerId);
    });
    frameBox.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      frameBox.scrollLeft = startLeft - dx;
    });
    function endDrag() { dragging = false; frameBox.classList.remove('is-dragging'); }
    frameBox.addEventListener('pointerup', endDrag);
    frameBox.addEventListener('pointercancel', endDrag);
    frameBox.addEventListener('pointerleave', function () { if (dragging) endDrag(); });
    /* a drag that actually moved the strip shouldn't also fire whatever's
       under the pointer when it's released */
    frameBox.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  } else {
    /* reduced motion or the strip is missing: paint the resting state once
       rather than leaving the ghost year on its authored "1966" and every
       mark unlit. */
    if (yearEl) yearEl.textContent = '2026';
    if (marks.length) marks[marks.length - 1].classList.add('active');
  }

  /* ==========================================================
     §2 · PRODUCT SLIDER — brand filter + slider-arrow wiring
     Replaces the bundle calculator on request 2026-08-05, then split
     into three brand-filtered views on the same day's second pass ("Add
     3 filter levels here for each brand… of which respectively will show
     3 products each"). Filtering just toggles `.is-filtered` on the
     eight not-currently-active cards — a wide viewport shows its three
     survivors in a static grid (tc60-v7.css §7 media query), so
     switching brands there is instant with nothing to scroll. The
     scroll-snap track and its prev/next arrows only do real work on a
     narrow viewport, where three cards can still overflow.
     ========================================================== */
  var pslide = document.querySelector('[data-pslide]');
  if (pslide) {
    var vp = pslide.querySelector('.pslide-viewport');
    var pTrack = pslide.querySelector('[data-pslide-track]');
    var cards = pTrack ? Array.prototype.slice.call(pTrack.querySelectorAll('.pslide-card')) : [];
    var fill = pslide.querySelector('[data-pslide-fill]');
    var prevBtn = pslide.querySelector('[data-pslide-prev]');
    var nextBtn = pslide.querySelector('[data-pslide-next]');
    var filterBar = document.querySelector('[data-pfilter]');
    var filterBtns = filterBar ? Array.prototype.slice.call(filterBar.querySelectorAll('.pfilter-btn')) : [];

    if (vp && cards.length) {
      function updateFill() {
        var max = vp.scrollWidth - vp.clientWidth;
        var p = max > 0 ? clamp(vp.scrollLeft / max, 0, 1) : 0;
        if (fill) fill.style.width = (p * 100) + '%';
        if (prevBtn) prevBtn.disabled = vp.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = max <= 2 || vp.scrollLeft >= max - 2;
      }

      var pPending = false;
      function pQueue() {
        if (pPending) return;
        pPending = true;
        requestAnimationFrame(function () { pPending = false; updateFill(); });
      }
      vp.addEventListener('scroll', pQueue, { passive: true });
      window.addEventListener('resize', pQueue, { passive: true });
      pQueue();

      function cardStep() {
        var visible = cards.filter(function (c) { return !c.classList.contains('is-filtered'); });
        var gap = parseFloat(getComputedStyle(pTrack).columnGap || getComputedStyle(pTrack).gap || '0') || 0;
        return (visible[0] || cards[0]).getBoundingClientRect().width + gap;
      }
      if (prevBtn) prevBtn.addEventListener('click', function () {
        vp.scrollBy({ left: -cardStep(), behavior: reduce ? 'auto' : 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        vp.scrollBy({ left: cardStep(), behavior: reduce ? 'auto' : 'smooth' });
      });
    }

    if (filterBtns.length) {
      function applyFilter(brand) {
        cards.forEach(function (c) {
          c.classList.toggle('is-filtered', c.getAttribute('data-brand') !== brand);
        });
        filterBtns.forEach(function (b) {
          var active = b.getAttribute('data-filter') === brand;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (vp) { vp.scrollLeft = 0; pQueueSafe(); }
      }
      /* pQueue is declared inside the `if (vp && cards.length)` block above
         and may not exist if the slider markup is ever trimmed down to
         fewer than one card — guard rather than assume. */
      function pQueueSafe() {
        if (vp && cards.length && typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(function () {
            var max = vp.scrollWidth - vp.clientWidth;
            if (fill) fill.style.width = (max > 0 ? 0 : 100) + '%';
            if (prevBtn) prevBtn.disabled = true;
            if (nextBtn) nextBtn.disabled = max <= 2;
          });
        }
      }
      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { applyFilter(btn.getAttribute('data-filter')); });
      });
      /* Sonos is marked is-active in the markup, so match that on load. */
      var initial = filterBtns.filter(function (b) { return b.classList.contains('is-active'); })[0];
      applyFilter(initial ? initial.getAttribute('data-filter') : filterBtns[0].getAttribute('data-filter'));
    }
  }

  /* ==========================================================
     §14 · THEN & NOW — before/after drag-to-compare slider
     Ported from the pointer-tracking logic in
     sections/home-or-away.liquid ("Play your way at home or away") on
     request — same idea: a `clip-path: inset()` on the top ("after")
     layer, driven by a draggable handle whose own `left` moves with it.
     data-tn-* mirrors that section's data-ic-* naming so the two are easy
     to diff against each other; the drag math (updateFromClientX) is the
     same, this just skips per-instance tracking/analytics since this is
     a static mockup, not a live page.
     ========================================================== */
  var tnContainer = document.querySelector('[data-tn-container]');
  if (tnContainer) {
    var tnAfter = tnContainer.querySelector('[data-tn-after]');
    var tnHandle = tnContainer.querySelector('[data-tn-handle]');

    if (tnAfter && tnHandle) {
      var tnDragging = false;
      var tnPos = 50; // 0–100

      function tnUpdate(clientX) {
        var rect = tnContainer.getBoundingClientRect();
        if (!rect.width) return;
        var next = ((clientX - rect.left) / rect.width) * 100;
        tnPos = clamp(next, 0, 100);
        tnAfter.style.clipPath = 'inset(0 0 0 ' + tnPos + '%)';
        tnHandle.style.left = 'calc(' + tnPos + '% - 22px)';
      }

      function tnDown(e) {
        tnDragging = true;
        if (e.type === 'mousedown') tnUpdate(e.clientX);
        else if (e.touches && e.touches[0]) tnUpdate(e.touches[0].clientX);
      }
      function tnMove(e) {
        if (!tnDragging) return;
        if (e.type === 'mousemove') tnUpdate(e.clientX);
        else if (e.touches && e.touches[0]) tnUpdate(e.touches[0].clientX);
      }
      function tnUp() { tnDragging = false; }

      tnHandle.addEventListener('mousedown', tnDown);
      tnContainer.addEventListener('mousedown', tnDown);
      tnContainer.addEventListener('mousemove', tnMove);
      tnContainer.addEventListener('mouseleave', tnUp);
      window.addEventListener('mouseup', tnUp);

      tnHandle.addEventListener('touchstart', tnDown, { passive: true });
      tnContainer.addEventListener('touchstart', tnDown, { passive: true });
      tnContainer.addEventListener('touchmove', tnMove, { passive: true });
      window.addEventListener('touchend', tnUp);
    }
  }
})();
